function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_151_2404)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 4C0 1.79086 1.79086 0 4 0H60C62.2091 0 64 1.79086 64 4V39C64 41.2091 62.2091 43 60 43H4C1.79086 43 0 41.2091 0 39V4Z",
  fill: "#1D71B9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.6082 34.9662V20.6797L64.0353 20.7031V24.6494L61.0961 27.7892L64.0353 30.9594V34.9887H59.3432L56.8496 32.2373L54.3734 35L38.6082 34.9662Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M40.3067 33.3993V22.2518H49.7592V24.8198H43.3678V26.5632H49.6069V29.0888H43.3678V30.801H49.7592V33.3993H40.3067Z",
  fill: "#1D71B9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M49.7125 33.3992L54.9418 27.8194L49.7125 22.2526H53.76L56.9561 25.7853L60.1608 22.2526H64.0353V22.34L58.9167 27.8194L64.0353 33.2417V33.3992H60.1219L56.8695 29.831L53.6501 33.3992H49.7125Z",
  fill: "#1D71B9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M39.7945 8H45.9237L48.0763 12.8885V8H55.6435L56.9483 11.6625L58.2574 8H64.0353V22.2856H33.5L39.7945 8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M40.9556 9.55225L36.0091 20.6902H39.4016L40.3344 18.4597H45.3907L46.3234 20.6902H49.7998L44.8742 9.55225H40.9556ZM41.3804 15.9601L42.8634 12.4144L44.3455 15.9601H41.3804Z",
  fill: "#1D71B9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M49.754 20.6883V9.55038L54.5222 9.56682L56.976 16.4142L59.4462 9.55038H64.0353V20.6883L61.0823 20.7143V13.0632L58.2946 20.6883H55.5985L52.7528 13.0372V20.6883H49.754Z",
  fill: "#1D71B9"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_151_2404"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 4C0 1.79086 1.79086 0 4 0H60C62.2091 0 64 1.79086 64 4V39C64 41.2091 62.2091 43 60 43H4C1.79086 43 0 41.2091 0 39V4Z",
  fill: "white"
})));

function SvgAmexMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 43,
    viewBox: "0 0 64 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmexMedium);
export default __webpack_public_path__ + "static/media/amex-medium.921298c9.svg";
export { ForwardRef as ReactComponent };